import React from "react";

import SearchInput from "./SearchInput";

const AddSevenSendersCarrier = ({
  sevenSendersCarrierName,
  sevenSendersService,
  sevenSendersCountry,
  sevenSendersServiceId,
  sevenSendersReturnMethodName,
  onChange,
}) => (
  <>
    <SearchInput
      type="text"
      placeholder="Carrier Name"
      name="sevenSendersCarrierName"
      value={sevenSendersCarrierName}
      onChange={onChange}
    />

    <SearchInput
      type="text"
      placeholder="Service"
      name="sevenSendersService"
      value={sevenSendersService}
      onChange={onChange}
    />

    <SearchInput
      type="text"
      placeholder="Service ID"
      name="sevenSendersServiceId"
      value={sevenSendersServiceId}
      onChange={onChange}
    />

    <SearchInput
      type="text"
      placeholder="Country"
      name="sevenSendersCountry"
      value={sevenSendersCountry}
      onChange={onChange}
    />

    <SearchInput
      type="text"
      placeholder="Return Method Name"
      name="sevenSendersReturnMethodName"
      value={sevenSendersReturnMethodName}
      onChange={onChange}
    />
  </>
);

export default AddSevenSendersCarrier;
